import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { useTranslate } from 'react-admin';

import { DeviationType, DeviationTypeByMainCategory } from '../../../entities/DeviationType';

export const TypeFilterField = ({ value, onChange, categoryValue }) => {
	const translate = useTranslate();
	
	const handleChange = (e) => {
		onChange && onChange(e.target.value === "" ? undefined : e.target.value);
	};

	const types = React.useMemo(() => {
		const typeObj = categoryValue !== undefined ? DeviationTypeByMainCategory[categoryValue] || {} : DeviationType;
		return Object.entries(typeObj).map(([key, id]) => ({
			id,
			name: translate(`osfc.enums.deviation_type.${key}`)
		}));
	}, [categoryValue, translate]);

	return (
		<TextField
			select
			label={translate("resources.deviations.export-dialog.fields.type")}
			variant="outlined"
			margin="none"
			size="small"
			value={value !== undefined ? value : ""}
			onChange={handleChange}
			style={{ width: 200, marginLeft: 8 }}
		>
			<MenuItem value="">All</MenuItem>
			{types.map(type => (
				<MenuItem key={type.id} value={type.id}>
					{type.name}
				</MenuItem>
			))}
		</TextField>
	);
};